import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { SearchService } from 'src/services';
import { Services } from 'src/services/types';
import { myContainer } from 'src/services/inversify.config';
import { IAccreditationsConfig } from '@orcha/types/package';
import { FeatureAppsConfiguration } from '@orcha/micro-library-widgets-ui';

export const appFeatureListDataFetcher = (
  widgetConfiguration: {
    apps: Omit<
      FeatureAppsConfiguration,
      | 'handleDownloadClick'
      | 'handleViewAppDetailsClick'
      | 'transformedPlatformData'
    >[];
  },
  site: IMicrositeConfiguration,
  locale?: string,
  country?: string | undefined,
  accreditationsConfig?: IAccreditationsConfig
) => {
  const searchService = myContainer.get<SearchService>(Services.SearchService);

  const getResults = async () => {
    try {
      if (widgetConfiguration.apps && Array.isArray(widgetConfiguration.apps)) {
        const appIds = widgetConfiguration.apps
          .map((appConfig) => appConfig.appId)
          .filter(Boolean);

        if (appIds.length > 0) {
          const result = await searchService.getSearchResults(
            site.tenantId,
            site.packageId,
            site.appContainerId,
            {
              ids: appIds,
              language: locale,
              IncludeAllCommissionableApps: true,
              country,
            },
            accreditationsConfig
          );
          return result?.apps;
        }
      }
    } catch (error) {
      console.error(
        'there was an error fetching the app feature list data:',
        error
      );
      return [];
    }
  };

  return getResults();
};
